export default "__VITE_ASSET__l7zlR7CC__"